<template>
  <div v-if="$store.state.warning.warningFalg">
    <div class="modal-backdrop fade in" style="z-index: 1040;"></div>
    <div
      class="modal fade ng-isolate-scope in"
      animate="animate"
      style="z-index: 1050; display: block;"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="inmodal">
            <div class="modal-content animated fadeIn">
              <div class="modal-header">
                <button type="button" class="close" @click.stop="cancel">
                  <span aria-hidden="true">&times;</span>
                  <span class="sr-only">Close</span>
                </button>
                <span class="text-warning">
                  <i class="fa fa-exclamation-triangle modal-icon"></i>
                </span>
                <h4 class="modal-title">Warning</h4>
              </div>
              <div class="modal-body">
                <p class="wrap">{{$store.state.warning.warningMsg}}</p>
              </div>
              <div class="modal-footer" id="warnBtnWrap" @click.stop="cancel">
                <slot></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "warningDlgController",
  data() {
    return {};
  },
  methods: {
    cancel: function() {
      this.$store.commit("setwarning", { string: "", boolean: false });
    }
  },
  mounted: function() {}
};
</script>
